import { memo } from 'react';
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  useEventCallback,
} from '@mui/material';
import { FormActualResidenceVM, ForeignVM } from 'practice/view-models/pratice-actual-residence';
import { FormikErrors, FormikTouched } from 'formik';
import ItalianForm from 'practice/components/edit/form/step-residence/modal-new-residence/italian';
import ForeignForm from './foreign';
import { ItalianVM } from 'shell/view-models/register-office-practice-vm';

interface FormProps {
  values?: FormActualResidenceVM;
  ForPracticeTemporary?: boolean;
  onChange: (
    key: keyof FormActualResidenceVM,
    value: FormActualResidenceVM[keyof FormActualResidenceVM]
  ) => void;
  errors?: FormikErrors<FormActualResidenceVM>;
  touched?: FormikTouched<FormActualResidenceVM>;
  disabled?: boolean;
  isEmigr?: boolean;
  typeResidence?: string;
}

const AccordionActualReidenceFormComponent = ({
  values,
  onChange,
  errors,
  touched,
  ForPracticeTemporary,
  disabled,
  isEmigr = false,
  typeResidence,
}: FormProps): React.ReactElement => {
  const onChangeItalian = useEventCallback(
    (key: keyof ItalianVM, value: ItalianVM[keyof ItalianVM]) => {
      onChange('italian', {
        ...(values?.italian || {}),
        [key]: value,
      });
    }
  );

  const onChangesItalian = useEventCallback((valuesItalian: ItalianVM) => {
    onChange('italian', {
      ...(values?.italian || {}),
      ...(valuesItalian || {}),
    });
  });

  const onChangeForeign = useEventCallback(
    (key: keyof ForeignVM, value: ForeignVM[keyof ForeignVM]) => {
      onChange('foreign', {
        ...(values?.foreign || {}),
        [key]: value,
      });
    }
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Residenza"
            id="checkedResidence"
            value={values?.checkedResidence || 'false'}
            onChange={() => {
              onChange('checkedResidence', !Boolean(values?.checkedResidence));
            }}
          >
            <FormControlLabel
              disabled={disabled}
              value="false"
              control={<Radio />}
              label="Residenza Italia"
            />
            <FormControlLabel
              disabled={disabled}
              value="true"
              control={<Radio />}
              label="Residenza Estera"
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      {values?.checkedResidence ? (
        <ForeignForm
          onChange={onChangeForeign}
          ForPracticeTemporary={ForPracticeTemporary}
          values={values?.foreign}
          errors={errors?.foreign as unknown as FormikErrors<ForeignVM>}
          touched={touched?.foreign as unknown as FormikTouched<ForeignVM>}
          disabled={disabled}
        />
      ) : (
        <ItalianForm
          onChange={onChangeItalian}
          onChanges={onChangesItalian}
          values={values?.italian}
          errors={errors?.italian as unknown as FormikErrors<ItalianVM>}
          touched={touched?.italian as unknown as FormikTouched<ItalianVM>}
          disabled={disabled}
          isEmigr={isEmigr}
          typeResidence={typeResidence}
        />
      )}
    </Grid>
  );
};

AccordionActualReidenceFormComponent.displayName = 'Accordion Actual Residence Form';

const AccordionActualReidenceForm = memo(AccordionActualReidenceFormComponent);

export default AccordionActualReidenceForm;
